import React from 'react';

export default function Mastfoot() {
  return (
    <footer className="border-avaris flex w-full flex-col items-start border-t p-8 font-trispace type-nav-label text-black">
      <p>© 2026 Avaris AS. All rights reserved</p>
      <p>Oslo, Norway</p>
    </footer>
  );
}
